var map = {
	"./Friday.webp": 212,
	"./Monday.webp": 213,
	"./Saturday.webp": 214,
	"./Sunday.webp": 215,
	"./Thursday.webp": 216,
	"./Tuesday.webp": 217,
	"./Wednesday.webp": 218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 211;